export default {
  version: 'v4.6.1.1'
}



// WEBPACK FOOTER //
// ./src/assets/config/index.js